import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { MycontentserviceService } from './mycontentservice.service';

@Injectable({
  providedIn: 'root'
})

export class WatchHistoryService {
  watchHistorySubject = new BehaviorSubject<any[]>([]);
  watchHistory$ = this.watchHistorySubject.asObservable();
  private hasLoaded = false;

  constructor(private mycontentService: MycontentserviceService) {}

  loadUserWatchHistory(): void {
    if (this.hasLoaded) return;

    this.mycontentService.getUserWatchHistory().subscribe((movies) => {
      const uniqueMovies = this.removeDuplicates(movies).map((movie) =>
        this.mycontentService.transformData(movie)
      );
      this.watchHistorySubject.next(uniqueMovies);
      this.hasLoaded = true;
    });
  }

  getWatchHistory(): Observable<any[]> {
    this.loadUserWatchHistory();
    return this.watchHistory$;
  }

  addToWatchHistory(movie: any): void {
    const current = this.watchHistorySubject.value;
    const updated = [this.mycontentService.transformData(movie), ...current.filter(m => m.vidLibId !== movie.vidLibId)];
    this.watchHistorySubject.next(updated);
  }

  removeFromWatchHistory(vidLibId: string): void {
    const updated = this.watchHistorySubject.value.filter(movie => movie.vidLibId !== vidLibId);
    this.watchHistorySubject.next(updated);
  }

  removeDuplicates(data) {
    const tempObj = {};
    const finalResult = [];
    for(const ele of data) {
      if(!tempObj[ele.vidLibId]){
        finalResult.push(ele);
        tempObj[ele.vidLibId] = ele.vidLibId;
      }
    }
    return finalResult;
  }
}